import React, {useState, useContext} from "react";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Container";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import {create, getCommitedGame, getUsersBenefitsHeaders, getUsersCommitedTotal} from "../../api/games";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {validation} from "../../services/validation";
import { renderForm } from "@components/Form/renderForm";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

export const TestCode = () => {
    const onCallback = (e) => {
        formValues.forEach((column) => {
            if (column.name === e.target.name) {
                column.value = e.target.value;
                column.error = '';
            }
        })
        setFormValues([...formValues]);
    }

    const data = [
        {name: 'segments', headerName: 'segments', value: [], error: '', label: 'Segments', type: 'segment', onCallback},
        {name: 'assignReason', headerName: 'assignReason', value: '', error: '', label: 'Assign Reason', items: ['FREE', 'PURCHASED'], type: 'enum', onCallback},
        {name: 'expirationOn', headerName: 'expirationOn', value: new Date(), error: '', type: 'date', onCallback},
        {name: 'purchasedDesc', headerName: 'purchasedDesc', value: '', error: '', type: 'string', onCallback},
        {name: 'shopperId', headerName: 'userId', value: '', error: '', type: 'string', onCallback},
        {name: 'languageIndex', headerName: 'languageIndex', value: '1', error: '', label: 'Language Index', items: ['1', '2'], type: 'enum', onCallback},
        // {name: 'category', headerName: 'category', value: '', error: '', type: 'string', inputProps: {required: true, pattern: `[a-z]+`, minLength: 2}, onCallback},
    ]
    const [formValues, setFormValues] = useState(data);
    const [userGamesHistory, setUserGamesHistory] = useState()
    const [pageInfo, setPageInfo] = useState({})
    const [userTotalCommitedGames, setUserTotalCommitedGames] = useState()
    const [userCommitedBarcodes, setUserCommitedBarcodes] = useState()
    const [game, setGame] = useState(null)
    const [commitedGame, setCommitedGame] = useState(null)
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const [page, setPage] = useState(1)
    const [shopperInputId, setShopperInputId] = useState()

    const handlePageChange = async (e, value) => {
            try {
                e.preventDefault();
                setLoading(true);
                setErrorMessage(null);
    
                setPage(value);
                const [body] = await getUsersBenefitsHeaders(shopperInputId, 5, value - 1);
                setUserCommitedBarcodes(body);
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
      };
    
    const clearForm = () => {
        formValues.forEach((formValue) => {
            if(formValue.name === "shopperId") {
                return formValue
            }
            else {
                const {value} = data.find(({name}) => name === formValue.name);

                formValue.value = value;
            }
        })
        setFormValues([...formValues])
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            setLoading(true);
            setErrorMessage(null);
            const objVal = {};
            formValues.forEach((formValue) => {
                objVal[formValue.name] = formValue.value;
            })
            const {assignReason, purchasedDesc, expirationOn, shopperId, segments} = objVal;
            const {value: languageIndex} = formValues.find(({name}) => name === 'languageIndex')

            await create({assignReason,
                purchasedDesc,
                expirationOn: moment(expirationOn,'DD-MM-YYYYY'),
                shopperId,
                segments,
                languageIndex}).then((res) => setGame(res)).then(data => console.log(data));
            setShopperInputId(shopperId)
            await getBenefitOfUser(shopperId)
            // eslint-disable-next-line no-unused-vars
            const [body, headers] = await getUsersBenefitsHeaders(shopperId, 5, 0);
            setPageInfo(headers)
            setUserCommitedBarcodes(body);
        } catch (e) {
            validation(e, formValues, (formValues) => {
                return setFormValues([...formValues]);
            })
            setErrorMessage(e);
        }
        setLoading(false);
    };

    const getBenefitOfUser = async (userId) => {
        await getUsersBenefitsHeaders(userId, 5, page).then(res => setUserGamesHistory(res));
        await getUsersCommitedTotal(userId).then(res => setUserTotalCommitedGames(res.total))
    }

    const commitGame = async () => {
        try {
            setLoading(true);
            setErrorMessage(null);
            const res = await getCommitedGame(game)
            setCommitedGame(res)
            clearForm();
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }


    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography component="p">Fill up the form</Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{mt: 1}}
                >
                    {formValues.map((data, key) => {
                        return renderForm(data, key);
                    })}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        Register Game
                    </Button>
                    <Card>Game Id: {game != null ? game.id : "no game id, make request"}</Card>
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                        onClick={e => commitGame(e)}
                    >
                        Commit the Game
                    </Button>
                    <Card>Result : {commitedGame?.actualBenefit.result} </Card>
                    {/*<Card>Win chance : {commitedGame?.winChance.winChance * 100 + '%'} </Card>*/}
                    <Card>Bar code
                        : {commitedGame?.actualBenefit.result === "WIN" ? "TYPE:" + commitedGame?.actualBenefit.type + "| Code:" + commitedGame?.actualBenefit.barCode.code : "No bar code"} </Card>
                </Box>
            </Box>
            <Box
                sx={{
                    marginTop: 8,
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
            <Typography component="p">User's total commited games: {userTotalCommitedGames} </Typography>  
            <Typography component="span">User's barcodes: 
            {userCommitedBarcodes?.map((e, i) => (
                <Box key={i}  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    border: "1px solid #333"
                }}>
                <Box component="div" sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                }}>
                <Typography>{e.barCode?.code}</Typography>
                <Typography>{e.result}</Typography>
                <Typography>Type: {e.type?.toString()}</Typography>
                <Typography>Descriptions: {e.descriptions?.toString()}</Typography>
                <Typography>Valid until: {e.validity}</Typography>
                <Typography>Supplier: {e.supplier}</Typography>
                <Typography>Status: {e.status}</Typography>
                <Typography>Bar Code status: {e.barCode?.status}</Typography>
                <Typography>Stores: {e.stores?.toString()}</Typography>
                <Typography>Discount: {e.discount}</Typography>
                </Box>
                <img src={e.imageUrl} style={{width: "200px"}} alt="Coupon or postcard"/>
                </Box>
            ))} 
            </Typography>
            <Stack spacing={2}>
                <Typography>Page: {page}</Typography>
                <Pagination count={pageInfo.pages} page={page} onChange={handlePageChange} />
            </Stack>        
            </Box>
        </Container>
    );
};
